import { render, staticRenderFns } from "./CBOffers.vue?vue&type=template&id=478449f1"
import script from "./CBOffers.vue?vue&type=script&lang=js"
export * from "./CBOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports